export default __webpack_public_path__ + "assets/media/airplane.d1d0de3a.png";